import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Tooltip } from 'antd';
import settings from 'settings';

const formDocLink = (resource = '') => `${settings.SHAREPOINT_BASE_ADDRESS()}${resource}`;

const DocLink = ({
  showIcon, page, children, toolTipText
}) => (
  <Tooltip title={toolTipText} placement="bottomRight">
    <a href={formDocLink(page)} target="_blank" rel="noopener noreferrer">
      {showIcon && <Icon type="question-circle" theme="filled" style={{ fontSize: '22px', color: 'white', paddingBottom: '2px' }} />}
      {children}
    </a>
  </Tooltip>
);

DocLink.propTypes = {
  page: PropTypes.string.isRequired,
  children: PropTypes.any,
  showIcon: PropTypes.bool,
  toolTipText: PropTypes.string
};

DocLink.defaultProps = {
  showIcon: true,
  toolTipText: 'Show Documentation',
  children: ''
};

export default DocLink;
